wbApp.filter('activityStatus', ['$translate', function ($translate) {
    return function (input) {
        switch (input) {
            case 0:
                return $translate.instant('TXT_STATUS_PRESENT');
            case 1:
                return $translate.instant('TXT_STATUS_NOT_PRESENT_NOT_EXCUSED');
            case 2:
                return $translate.instant('TXT_STATUS_NOT_PRESENT_EXCUSED');
            case 3:
                return $translate.instant('TXT_STATUS_NOT_PRESENT_EXCUSED_NO_COMPENSATION');
            case 4:
                return $translate.instant('TXT_STATUS_NOT_PRESENT_EXCUSED_NO_FOOD');
        }
        
    };
}]);